// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:21
import { UnitActivityLogCallCard_abstract } from './../abstract/SagaSchema/UnitActivityLogCallCard_abstract';
export class UnitActivityLogCallCard extends UnitActivityLogCallCard_abstract {}
